export default "__VITE_ASSET__D4A435Yo__"